export const SecurityShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.5 19.7749L1.75 15.1697V2.26038L2.96075 2.66396C5.03783 3.35632 7.31375 3.10648 9.19117 1.98003L10.5235 1.18066L11.4502 1.79853C13.3097 3.03816 15.6251 3.38401 17.7657 2.74185L19.25 2.29654V15.1697L10.5 19.7749Z" fill="#44BD42" />
  </svg>
);
